/**
 * ExerciseCopyright — kept as a no-op wrapper because the global
 * `MobileBrandStrip` at the App root now handles the brand mark + copyright
 * in a consistent place for every exercise modal. Rendering nothing here
 * avoids double-branding and clears the bottom-left corner.
 */
const ExerciseCopyright = () => null;

export default ExerciseCopyright;
